import React from 'react'

const BooleanStatus = ({_bool,first,second}) => {
  return (
   <div className={`rounded-full px-2 py-1 text-xs  text-white ${_bool?"bg-green-500":"bg-gray-500"}`}>{_bool?second:first}</div>

  )
}

export default BooleanStatus